/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 17:28 2020/10/16
 */

import * as Vue from 'vue-tsx-support';
import { Component } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import _ from 'lodash';
import './head.less';
import { createBEM } from 'src/util/bem';
import RouteUtils from 'src/util/routeUtils';
import RoleConfigApi from 'src/pages/systemConfig/roleConfig/api/roleConfigApi';
import { LoginDOI } from 'src/pages/login/loginApi';
import LocalStore from 'src/util/LocalStore';
import EnumAuthorityType from 'src/enums/enumAuthorityType';
import { MenuI } from 'src/pages/store/modules/layout';
import { CommonUtil } from 'src/util/commonUtil';
import alertUpdatePasswordModal from './updatePasswordModal';
import alertUpdateOpinionFeedbackModal from './updateOpinionFeedbackModal';
import alertUserOperateModal from 'src/pages/systemConfig/userConfig/userOperateModal';
import EnumOperates from 'src/enums/enumOperates';
let bem = createBEM('top-head');
@Component
export default class Head extends Vue.Component<any> {
    username: string = '';
    authorityMenusMap: {[str: string]: boolean} = {};
    menusListLength:number;
    // 系统名称
    system_name: string = "";
    // 英文系统名称
    english_system_name: string = "";

    clickMenu(menu) {
        if (menu.children && menu.children.length > 0) {
            return;
        }
        RouteUtils.goTo(menu.path);
    }
    clickSubMenu(menu) {
        if (menu.children && menu.children.length > 0) {
            this.$store.commit('layout/saveCurrentPageMenus', menu.children);
            // 跳转下级第一个子菜单的路由
            RouteUtils.goTo(menu.children[0].path);
            return;
        }
        RouteUtils.goTo(menu.path);
    }

    //个人信息
    personalinfo() {
        let userInfo: LoginDOI.LoginResultI = LocalStore.getData('userInfo');
        alertUserOperateModal(EnumOperates.Detail.getName(), userInfo.user_id)
    }

    //修改密码
    updatePassword() {
        alertUpdatePasswordModal()
    }

    //意见反馈
    opinionFeedback() {
        alertUpdateOpinionFeedbackModal();
    }

    loginout() {
        // LocalStore.clearData('userInfo')
        RouteUtils.goTo('/login')
    }


    async mounted() {
        let userInfo: LoginDOI.LoginResultI = LocalStore.getData('userInfo');
        this.username = userInfo.username;
        let { code, data } = await RoleConfigApi.queryMenus();
        if (code === 0) {
            let authorityMenusMap: {[str: string]: boolean} = {}
            data.forEach(i=> {
                authorityMenusMap[i.power_url] = true
            })
            this.authorityMenusMap = authorityMenusMap
            console.log('系统全部路由', this.$store.state.layout.menus)
            console.log('角色对应路由', this.authorityMenusMap)
            console.log('this.menu->匹配到的路由', this.menu)
        }
        if (userInfo.system_name !== undefined) {
            this.system_name = userInfo.system_name;
        }
        if(userInfo.english_system_name !== undefined) {
            this.english_system_name = userInfo.english_system_name;
        }
    }

    get menu():any {
        let menus:MenuI[] = JSON.parse(JSON.stringify(this.$store.state.layout.menus))
        let t = this
        function filterMenu(menus:MenuI[]):MenuI[] {
            return menus.filter(i=> {
                if(CommonUtil.isArray(i.children) && i.children!.length>0) {
                    i.children = filterMenu(i.children as any)
                }
                if(!i.children && t.authorityMenusMap[i.path] || !CommonUtil.isResultEmpty(i.children)) {
                    return true
                } else {
                    return false
                }
            })
        }
        var menusList = filterMenu(menus);
        this.menusListLength = menusList.length;
        return menusList
    }
    render(h) {
        console.log('this.$route', this.$route);
        return (
            <div class={bem()}>
                <div class={bem('side', 'left')} />
                <div class={bem('side', 'right')} />
                <div class={bem('center')}>
                    <div class={bem('center-text')} on-click={()=> {RouteUtils.goTo('/main')}}>
                        {/* <img src={require('../../../assets/images/head-text.png')} width="233"/> */}
                        <p v-if={this.system_name.length > 11} class={bem('head-text-11')}>{this.system_name}</p>
                        <p v-else class={bem('head-text')}>{this.system_name}</p>
                        <p v-if={this.system_name.length > 11} class={bem('head-text-en-11')}>{this.english_system_name}</p>
                        <p v-else class={bem('head-text-en')}>{this.english_system_name}</p>
                    </div>
                    <div class={bem('menu')}>
                        {/* {this.$store.state.layout.menus.map(i => { */}
                            {this.menu.map(i => {
                            return (
                                <div
                                    class={bem('menu-item', { active: this.$route.fullPath.indexOf(i.path) === 0 })}
                                    onClick={this.clickMenu.bind(this, i)}
                                >
                                    {i.title}
                                    <div v-if={i.children && i.children.length > 0} class={bem('sub-menu')}>
                                        {i.children.map(sub => {
                                            return (
                                                <div class={bem('sub-menu-item')} onClick={this.clickSubMenu.bind(this, sub)}>
                                                    {sub.title}
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    <div class={bem('info')}>
                        <p><i class="icon-yonghu wqms-font" />
                        <span>{this.username}</span></p>
                        <div class={bem('sub-menu')}>
                            <div class={bem('sub-menu-item')} on-click={this.personalinfo.bind(this)}>个人信息</div>
                            <div class={bem('sub-menu-item')} on-click={this.updatePassword.bind(this)}>修改密码</div>
                            <div class={bem('sub-menu-item')} on-click={this.opinionFeedback.bind(this)}>意见反馈</div>
                            <div class={bem('sub-menu-item')} on-click={this.loginout.bind(this)}>退出登录</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
